import React, { useReducer, useContext, useEffect } from 'react'
import axios, { getAdapter } from 'axios';
import { lockedReducer } from '../../Utils/reducers'
import { api, downloadFile } from '../../../services/api'
import ColorButton from '../../Buttons/ColorButton';
import DefaultModal from '../../Utils/DefaultModal';
import toast from 'react-hot-toast'
import {
    Box, Tooltip, Stepper, Step, StepLabel,
    ListItemButton, ListItemText, List, ListItem, Autocomplete,
    TextField, FormControl, MenuItem, InputLabel, Select,
} from '@mui/material'
import { CircularProgress } from '@mui/material';
import timeoutList from '../../Utils/TimeoutList';
import validateData from './validateData';
import { externalComponent } from '../../AppRoutes';
import { getSession } from '../../../contexts/auth';
import apptheme from '../../theme/default';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import { defaultBackend } from '../../../services/api';
import { MobileDateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { generateReport } from '../Schedule/Edit-schedule-modal';
import { generateProposal } from '../Proposal/Edit-proposal-modal';
import PostPayment from './postpayment';
import { maskedTable } from '../../Utils/MaskedInput';
import { number2dayweek, actionBar } from '../../Utils/dayjsptbrhelper';
import IntegerOnly from '../../Utils/IntegerOnly';
import ShowDisponibility from '../Schedule/show-disponibility';
import ServiceSelection from '../Proposal/serviceselection';

import { NumericFormatInput } from '../../Utils/MaskedInput';
import { capitalize } from '../../Utils/functions';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CancelIcon from '@mui/icons-material/Cancel';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { formatClientLabel } from '../../Utils/functions';

import EditIcon from '@mui/icons-material/Edit';

const url = '/order/serviceorder/'

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const duplicar = async (state, setState, setLoader, getData) => {
    setLoader(true);  // Mostra o carregamento
    let res = null;

    try {
        res = await api.post('/order/serviceorder/create_child/', state);  // Envia os dados para duplicar
        if (res.status === 201 || res.status === 200) {
            toast.success(`Ordem de serviço ${res.status === 201 ? 'adicionada' : 'editada'} com sucesso`);
            getData()
            res.data.teams = res.data.teams_serialized;
            setState({ ...res.data, step: 1 });
            setLoader(false);
            return;
        }
        toast.error(`Ordem de serviço não pôde ser duplicada. Motivo: ${res.data.detail}`);
    } catch (error) {
        toast.error('Erro ao duplicar a ordem de serviço.');
    } finally {
        setLoader(false);
    }
};

const getTotalValue = async (orderid, setState) => {
    const res = await api.get(url + `${orderid}/proposal_value/`)
    if (res.status === 200) {
        const [total_value, prepayment, teams] = res.data
        setState({ loaded: true, total_value: total_value, prepayment: prepayment, teams: teams })
    }

}

const loadProposalRow = async (id, setState, setLoader) => {
    setLoader(true)
    const res = await api.get(url + `${id}/`)
    if (res.status === 200) {
        res.data.teams = res.data.teams_serialized
        setState({ ...res.data, step: 1, loaded: true, saved: true })
    }
    setLoader(false)
}

const cancel = async (id, getData, setLoader, setState, message = '') => {
    setLoader(true)
    const res = await api.post(url + `${id}/cancel/`, { message: message })
    setLoader(false)
    if (res.status === 200) {
        toast.success(`Ordem de serviço cancelada com sucesso`)
        getData()
        res.data.teams = res.data.teams_serialized
        setState({ ...res.data, step: 1 })
    }
}

const submit = async (data, getData, setLoader, setState) => {

    setLoader(true)
    let res = null

    if (data.id)
        res = await api.patch(`${url}${data.id}/`, data)
    else
        res = await api.post(url, data)
    if (res.status === 201 || res.status === 200) {
        toast.success(`Ordem de serviço ${res.status === 201 ? 'adicionada' : 'editada'} com sucesso`)
        getData()
        res.data.teams = res.data.teams_serialized
        setState({ ...res.data, step: 1 })
        setLoader(false)
        return
    }
    toast.error(`Ordem de serviço não pôde ser ${!data.id ? 'adicionada' : 'editada.'} Motivo: ${res.data}`)
    setLoader(false)
}


const generateServiceOrder = async (id, setLoader) => {
    setLoader(true)
    const res = await api.post(url + `${id}/generate/`)
    if (res.status === 200) {
        downloadFile(defaultBackend.replace('api/', '') + res.data + '/')
    }
    setLoader(false)
}

const generateDocument = async (id, docid, setLoader) => {
    setLoader(true)
    const res = await api.post(url + `${id}/generatedocument/${docid}/`)
    if (res.status === 200) {
        downloadFile(defaultBackend.replace('api/', '') + res.data + '/')
    }
    setLoader(false)
}

const disponibilityVerify = async (state, setLoader, setState) => {
    const date = dayjs(state.datetime)
    const duration = state.duration
    const nextDate = date.add(duration, 'minutes')

    setLoader(true)
    const res = await api.post('/order/serviceorder/disponibilityVerify/', {
        //order_id: state.order_id || state.order.id,
        teams: state.teams,
        newDate: date.format('YYYY-MM-DD HH:mmZ'),
        nextDate: nextDate.format('YYYY-MM-DD HH:mmZ'),
        datetime__gte: date.format('YYYY-MM-DD 00:00Z'),
        datetime__lt: date.add(1, 'day').format('YYYY-MM-DD 00:00Z'),
        data_only: true
    })
    setLoader(false)

    if (res.status === 406) {
        setState({ step: 0 })
        toast.error('Horário indisponivel')
    }

    if (res.status === 200) {
        setState({ step: state.step + 1 })
        toast.success('Horário disponivel')
    }
}

const getGarantee = async (setState) => {
    const validity = api.get('/order/proposal/validity/')
    const [validity_data] = await Promise.all([validity])
    const response = {}
    if (validity_data.status === 200)
        response.validity_list = validity_data.data

    setState(response)
}

const generateSteps = (state, setState, user, setLoader, directorder) => {

    return [
        {
            label: state.order?.id ? 'Agendamento' : 'Ordem de Serviço', component: (
                <>
                    {state.order?.id ? <>
                        <Box className='item-profile-row'>
                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                <MobileDateTimePicker
                                    size='small'
                                    label='Data e hora'
                                    value={dayjs(state.datetime)}
                                    format='DD/MM/YYYY HH:mm'
                                    sx={{ flex: 1 }}
                                    onChange={(e) => { setState({ 'datetime': e }) }}
                                    slotProps={{ textField: { size: 'small' } }}
                                    slots={{ toolbar: actionBar }}
                                    dayOfWeekFormatter={(n, date) => number2dayweek[date.$W]}
                                    ampm={false}
                                />
                                <TextField
                                    size='small'
                                    sx={{ flex: .3 }}
                                    label='Duração (minutos)'
                                    value={state.duration}
                                    onChange={(e) => setState({ duration: IntegerOnly(e.target.value, 0, 9999) })}
                                />

                            </Box>
                        </Box>

                        <Autocomplete
                            multiple
                            sx={{ flex: .8 }}
                            id={'autocompletebox-team'}
                            value={state.teams}
                            options={state.loaded_teams.filter(loaded => !state.teams.map(e => e.id).includes(loaded.id))}
                            onChange={(e, selectedTeam) => { setState({ teams: selectedTeam }) }}
                            autoHighlight
                            handleHomeEndKeys
                            clearText='Limpar'
                            size="small"
                            noOptionsText='Digite para pesquisar equipes'
                            loading={state.smallLoading}
                            onOpen={() => state.loaded_teams.length === 0 && timeoutList('', 'order/serviceorder/team/', 'loaded_teams', 'name', setState)}
                            onInputChange={(e, v) => { e?.type === 'change' && timeoutList(v, 'order/serviceorder/team/', 'loaded_teams', 'name', setState) }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    id={'autocompleteinput'}
                                    type="text"
                                    sx={{ backgroundColor: 'white' }}
                                    label="Equipe"
                                    size="small"
                                    fullWidth={true}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {state.smallLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            }
                        />

                    </>
                        :
                        <>
                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                <Autocomplete
                                    sx={{ flex: 1 }}
                                    id={'autocompletebox-seller'}
                                    value={state.new_seller}
                                    options={state.loaded_sellers.filter(each => state.new_seller?.id !== each.id)}
                                    onChange={(e, selectedseller) => { setState({ new_seller: selectedseller }) }}
                                    autoHighlight
                                    handleHomeEndKeys
                                    clearText='Limpar'
                                    noOptionsText='Digite para pesquisar Vendedor'
                                    onOpen={() => state.loaded_sellers.length === 0 && timeoutList('', 'order/serviceorder/seller/', 'loaded_sellers', 'first_name', setState)}
                                    loading={state.smallLoading}
                                    ChipProps={{ size: 'small' }}
                                    filterSelectedOptions
                                    onInputChange={(e, v) => { e?.type === 'change' && timeoutList(v, 'order/serviceorder/seller/', 'loaded_sellers', 'first_name', setState) }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            id={'autocompleteinput'}
                                            type="text"
                                            sx={{ backgroundColor: 'white' }}
                                            label="Vendedor"
                                            size="small"
                                            fullWidth={true}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {state.smallLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    }
                                />
                            </Box >

                            <Box className='item-profile-row' sx={{ flexDirection: 'column' }}>
                                <Autocomplete
                                    disabled={state.state !== ''}
                                    sx={{ flex: 1 }}
                                    id={'autocompletebox-client'}
                                    value={state.new_client}
                                    options={state.loaded_clients}
                                    onChange={(e, selectedClient) => {
                                        setState({ new_client: selectedClient });
                                        if (!selectedClient && state.loaded_clients.length > 0) {
                                            timeoutList('', 'order/schedule/client/', 'loaded_clients', 'name', setState, false, formatClientLabel);
                                        }
                                    }}
                                    autoHighlight
                                    handleHomeEndKeys
                                    clearText='Limpar'
                                    noOptionsText='Digite para pesquisar clientes (nome ou razão social)'
                                    loading={state.smallLoading}
                                    onOpen={() => {
                                        if (state.loaded_clients.length === 0 || (!state.new_client && state.loaded_clients.length > 0)) {
                                            timeoutList('', 'order/schedule/client/', 'loaded_clients', 'name', setState, false, formatClientLabel);
                                        }
                                    }}
                                    onInputChange={(e, v) => {
                                        if (e?.type === 'change') {
                                            timeoutList(v, 'order/schedule/client/', 'loaded_clients', 'name', setState, false, formatClientLabel);
                                        }
                                        if (v === '' && e?.type === 'change') {
                                            setTimeout(() => {
                                                timeoutList('', 'order/schedule/client/', 'loaded_clients', 'name', setState, false, formatClientLabel);
                                            }, 100);
                                        }
                                    }}
                                    onClose={() => {
                                        if (!state.new_client) {
                                            setTimeout(() => {
                                                timeoutList('', 'order/schedule/client/', 'loaded_clients', 'name', setState, false, formatClientLabel);
                                            }, 100);
                                        }
                                    }}
                                    getOptionLabel={(option) => {
                                        if (typeof option === 'string') return option;
                                        return option.label || '';
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            id={'autocompleteinput'}
                                            type="text"
                                            sx={{ backgroundColor: 'white' }}
                                            label="Cliente"
                                            size="small"
                                            fullWidth={true}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {state.smallLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    }
                                />
                            </Box>

                            <Box sx={{ width: '100%' }}>
                                <Accordion sx={{ width: '100%' }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <Typography component="span">Serviços</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ServiceSelection state={state} setState={setState} />
                                    </AccordionDetails>
                                </Accordion>
                            </Box>

                            <ListItemButton><ListItemText primary='Agendamento' /></ListItemButton>

                            <Box className='item-profile-row'>
                                <Box sx={{ display: 'flex', gap: '1rem' }}>
                                    <MobileDateTimePicker
                                        size='small'
                                        label='Data e hora'
                                        value={dayjs(state.datetime)}
                                        format='DD/MM/YYYY HH:mm'
                                        sx={{ flex: 1 }}
                                        onChange={(e) => { setState({ 'datetime': e }) }}
                                        slotProps={{ textField: { size: 'small' } }}
                                        slots={{ toolbar: actionBar }}
                                        dayOfWeekFormatter={(n, date) => number2dayweek[date.$W]}
                                        ampm={false}
                                    />
                                    <TextField
                                        size='small'
                                        sx={{ flex: .3 }}
                                        label='Duração (minutos)'
                                        value={state.duration}
                                        onChange={(e) => setState({ duration: IntegerOnly(e.target.value, 0, 9999) })}
                                    />
                                </Box>
                            </Box>

                            <Autocomplete
                                multiple
                                sx={{ flex: .8 }}
                                id={'autocompletebox-team'}
                                value={state.teams}
                                options={state.loaded_teams.filter(loaded => !state.teams.map(e => e.id).includes(loaded.id))}
                                onChange={(e, selectedTeam) => { setState({ teams: selectedTeam }) }}
                                autoHighlight
                                handleHomeEndKeys
                                clearText='Limpar'
                                size="small"
                                noOptionsText='Digite para pesquisar equipes'
                                loading={state.smallLoading}
                                onOpen={() => state.loaded_teams.length === 0 && timeoutList('', 'order/serviceorder/team/', 'loaded_teams', 'name', setState)}
                                onInputChange={(e, v) => { e?.type === 'change' && timeoutList(v, 'order/serviceorder/team/', 'loaded_teams', 'name', setState) }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        id={'autocompleteinput'}
                                        type="text"
                                        sx={{ backgroundColor: 'white' }}
                                        label="Equipe"
                                        size="small"
                                        fullWidth={true}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {state.smallLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                }
                            />
                        </>
                    }
                </>
            ),
        },
        ...(!state.order?.id ? [{
            label: 'Pagamento',
            component: (<>
                <Box sx={{ display: 'flex', gap: '1rem' }}>
                    <Autocomplete
                        sx={{ flex: 1 }}
                        id={'autocompletebox-payments'}
                        value={state.new_payment}
                        options={state.loaded_payment.filter(each => state.new_payment?.id !== each.id)}
                        onChange={(e, selectedPayments) => { setState({ new_payment: selectedPayments, new_payment_data: { ...state.new_payment_data, entry_value: '' } }) }}
                        autoHighlight
                        handleHomeEndKeys
                        clearText='Limpar'
                        noOptionsText='Digite para pesquisar formas de pagamento'
                        loading={state.smallLoading}
                        ChipProps={{ size: 'small' }}
                        filterSelectedOptions
                        onOpen={() => state.loaded_payment.length === 0 && timeoutList('', 'order/proposal/payments/', 'loaded_payment', 'name', setState)}
                        onInputChange={(e, v) => { e?.type === 'change' && timeoutList(v, 'order/proposal/payments/', 'loaded_payment', 'name', setState) }}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                id={'autocompleteinput'}
                                type="text"
                                sx={{ backgroundColor: 'white' }}
                                label="Forma de pagamento"
                                size="small"
                                fullWidth={true}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {state.smallLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        }
                    />
                </Box>
                <Box sx={{ display: 'flex', gap: '1rem' }}>
                    <TextField
                        sx={{ flex: 1 }}
                        label='Desconto'
                        size='small'
                        value={state.new_payment_data.discount || ''}
                        onChange={(e) => setState({ new_payment_data: { ...state.new_payment_data, discount: e.target.value } })}
                        inputProps={{ maxLength: 13 }}
                        InputProps={{
                            inputComponent: NumericFormatInput
                        }}
                    />
                    <TextField
                        sx={{ flex: 1 }}
                        label='Acréscimo'
                        size='small'
                        value={state.new_payment_data.addition || ''}
                        onChange={(e) => setState({ new_payment_data: { ...state.new_payment_data, addition: e.target.value } })}
                        inputProps={{ maxLength: 13 }}
                        InputProps={{
                            inputComponent: NumericFormatInput
                        }}
                    />
                    <TextField
                        sx={{ flex: 1 }}
                        disabled={!state.new_payment?.data?.first_parcel}
                        label='Entrada'
                        size='small'
                        value={state.new_payment_data?.entry_value || ''}
                        onChange={(e) => setState({ new_payment_data: { ...state.new_payment_data, entry_value: e.target.value } })}
                        inputProps={{ maxLength: 13 }}
                        InputProps={{
                            inputComponent: NumericFormatInput
                        }}
                    />

                    <FormControl sx={{ minWidth: 200, background: 'white', flex: 1 }} size='small' >
                        <InputLabel id="select-parcels-label">Parcelas</InputLabel>
                        <Select
                            labelId="select-parcels-label"
                            id="select-parcels"
                            label="Parcelas"
                            disabled={state.new_payment?.data?.parcel_fix}
                            value={state.new_payment?.data?.parcel_fix ? state.new_payment?.data?.parcel_count : state.new_payment_data?.parcels || ''}
                            onChange={(e) => { setState({ new_payment_data: { ...state.new_payment_data, parcels: e.target.value } }) }}
                        >
                            <MenuItem value={''}>Selecione *</MenuItem>

                            {Array.from({ length: state.new_payment?.data?.parcel_count || 0 }, (value, index) => index + 1)?.map(each =>
                                <MenuItem value={each}>{each}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ minWidth: 200, background: 'white', flex: 1 }} size='small' >
                        <InputLabel id="select-garantee-label">Validade da proposta</InputLabel>
                        <Select
                            labelId="select-garantee-label"
                            id="select-garantee"
                            label="Validade da proposta"
                            value={state.garantee}
                            onChange={(e) => { setState({ 'garantee': e.target.value }) }}
                        >
                            <MenuItem value={''}>Selecione *</MenuItem>
                            {state.validity_list.map(([key, value]) =>
                                <MenuItem value={key}>{capitalize(value)}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </Box>

                <TextField
                    multiline
                    maxRows={4}
                    size='small'
                    label={`Observação`}
                    className='simple-text'
                    value={state.observations}
                    onChange={(e) => { setState({ observations: e.target.value }) }}
                    inputProps={{
                        maxLength: 1000
                    }}
                />
            </>)
        }] : []),

        {
            label: 'Ações', component: (
                <>
                    {(user.permissions.view_schedule && state.order?.schedule) && directorder === false && <ColorButton
                        onClick={() => generateReport(state.order.schedule, setLoader)}
                    >
                        Ver Visita
                    </ColorButton>}
                    {(user.permissions.view_proposal) && directorder === false && <ColorButton
                        onClick={() => generateProposal(state.order.proposal, setLoader)}
                    >
                        Ver Proposta
                    </ColorButton>}
                    {(user.permissions.view_serviceorder && state.state !== '') && <ColorButton
                        onClick={() => generateServiceOrder(state.order.service_order, setLoader)}
                    >
                        Ver Ordem de serviço
                    </ColorButton>}
                    {(user.permissions.view_serviceorder && state.state !== '') && state.documents.map(each => <ColorButton
                        onClick={() => generateDocument(state.id, each.id, setLoader)}
                    >
                        Ver {each.name}
                    </ColorButton>)}
                    {(user.permissions.view_serviceorder && state.status !== 'Realizado') && Boolean(state.id) &&
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            <ColorButton
                                sx={{ width: '12rem' }}
                                onClick={() => setState({ newProducts: true })}
                            >
                                Alterar produtos
                            </ColorButton>
                        </Box>
                    }
                    <List className='proposal-resume-list'>
                        <ListItemButton><ListItemText primary='Cliente' secondary={state.client?.label || state.client_name} /></ListItemButton>
                        {state.total_value && <ListItemButton><ListItemText primary='Valor a pagar' secondary={maskedTable['value'](state.total_value)} /></ListItemButton>}
                        <ListItemButton><ListItemText primary='Confimar Data' secondary={dayjs(state.datetime).toDate().toLocaleString()} /></ListItemButton>
                        <ListItemButton><ListItemText primary='Equipes' secondary={state.teams.map(each => each.label).join(', ')} /></ListItemButton>
                        {state.state === 'CANCELLED' && <ListItemButton><ListItemText primary='Motivo do cancelamento' secondary={state.cancel_register} /></ListItemButton>}
                        {state.paid_value ? <>
                            <ListItemButton><ListItemText primary='Valor pago' secondary={maskedTable['value'](state.paid_value)} /></ListItemButton>
                        </> : null}
                        {state.postpayment_data?.length > 0 ? <>
                            <ListItemButton>
                                <ListItemText
                                    primary='Pagamento'
                                    secondary={(<List>
                                        {state.postpayment_data?.map(each => (
                                            <Box className='nopadding' sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <ListItem className='nopadding'>{each.parcels || each.data.parcel_count || 1}x {each.label}</ListItem>
                                                <ListItem sx={{ flex: 1, whiteSpace: 'pre' }} className='nopadding'> {maskedTable['value'](each.value)}</ListItem>
                                            </Box>))}
                                    </List>)} />
                            </ListItemButton>
                            <ListItemButton><ListItemText primary='Adicional' secondary={maskedTable['value'](state.additional)} /></ListItemButton>
                            <ListItemButton><ListItemText primary='Desconto' secondary={maskedTable['value'](state.discount)} /></ListItemButton>
                            {state.observation_register && <ListItemButton><ListItemText primary='Observação' secondary={state.observation_register} /></ListItemButton>}
                        </> : null}

                    </List>
                </>
            )
        }
    ]
}

const EditServiceOrderModal = ({ data, handleClose, reloadData, cloneRow, typeModal, directOrder }) => {

    const user = getSession()

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        id: 0,
        order: null,
        order_id: null,
        datetime: '',
        duration: 0,
        client: '',
        teams: [],
        services: [],
        loaded_teams: [],
        loaded: false,
        step: 0,
        confirmSubmit: null,
        state: '',
        paid_value: '',
        total_value: '',
        additional: 0,
        discount: 0,
        showpostpayment: null,
        postpayments: [],
        postpayment_data: [],
        payment_data: {},
        documents: [],
        proposal: {},
        saved: false,
        cancel_register: '',
        observation_register: '',
        showDisponibility: false,
        loaded_sellers: [],
        loaded_clients: [],
        loaded_services: [],
        loaded_payment: [],
        validity_list: [],
        new_payment: '',
        new_seller: '',
        new_payment_data: {},
        garantee: 0,
        observations: '',
        newProducts: false,
        changedServices: null,
        ...data
    })

    useEffect(() => {
        if (data.id) {
            loadProposalRow(data.id, setState, setLoader)
            return
        }

        if (!data.order?.id) {
            setState({ loaded: true })
            return
        }
        getTotalValue(data.order?.id, setState)


    }, [setLoader, data.id])

    useEffect(() => {
        getGarantee(setState)
    }, [])

    const validData = validateData(state)

    const stepsArray = generateSteps(state, setState, user, setLoader, directOrder)
    const maxStep = stepsArray.length - 1

    return (
        <>
            {state.showDisponibility &&
                <ShowDisponibility
                    id={state.id}
                    initialDay={state.datetime}
                    duration={state.duration}
                    submitDate={(datetime, duration) => { setState({ datetime: datetime, duration: duration, showDisponibility: false }) }}
                    handleClose={() => setState({ showDisponibility: false })}
                />
            }
            {state.confirmSubmit &&
                <ConfirmationDialog
                    title={state.confirmSubmit.title}
                    handleClose={() => setState({ confirmSubmit: null })}
                    onConfirm={state.confirmSubmit.function}
                    okButton={state.confirmSubmit.okButton}
                    content={state.confirmSubmit.content}
                    message={state.confirmSubmit.message}
                />}
            {state.loaded && <DefaultModal
                title={
                    `${getTitle(state)} Ordem de serviço`
                }
                handleClose={handleClose}
                dialogProps={{
                    maxWidth: 'sm'
                }}
                content={
                    <>
                        <Stepper activeStep={state.step}>
                            {stepsArray.map((step, index) => (
                                <Step key={step.label} >
                                    <StepLabel sx={{
                                        '.MuiStepIcon-root.Mui-active': { color: apptheme.primaryColor },
                                        '.MuiStepIcon-root.Mui-completed': { color: apptheme.primaryColor }
                                    }}>
                                        {step.label}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <Box className='item-content-modal noborder' sx={{ paddingTop: '1rem' }}>
                            {stepsArray[state.step].component}
                        </Box>
                    </>
                }
                action={
                    <>
                        <Box
                            className="action-right-options"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                flexWrap: 'nowrap',
                                width: '100%',
                                padding: '1.0rem',
                                justifyContent: 'space-between  '
                            }}
                        >
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                {(user.permissions.view_client && state.step === 0) && (
                                    <>
                                        <Tooltip title="Verificar disponibilidade">
                                            <ColorButton
                                                onClick={() => { setState({ showDisponibility: true }) }}
                                            >
                                                Disponibilidade
                                            </ColorButton>
                                        </Tooltip>
                                    </>
                                )}

                                {(state.step === maxStep && state.state === 'OPEN' && user.permissions.change_serviceorder) && (
                                    <ColorButton
                                        sx={{ backgroundColor: '#d32f2f', "&:hover": { backgroundColor: '#d32f2ff5' }, width: '2.5rem', height: '2.5rem' }}
                                        onClick={() => setState({
                                            confirmSubmit: {
                                                function: (message) => {
                                                    cancel(state.id, reloadData, setLoader, setState, message);
                                                    setState({ confirmSubmit: null });
                                                },
                                                title: 'Confirmar ação.',
                                                content: 'Deseja cancelar a ordem de serviço?',
                                                okButton: 'Sim',
                                                message: true
                                            }
                                        })}
                                        disabled={validData}
                                    >
                                        <CancelIcon />
                                    </ColorButton>
                                )}

                                {(state.step !== 0 && ['', 'OPEN'].includes(state.state)) && (
                                    <ColorButton
                                        sx={{ width: '2.5rem', height: '2.5rem' }}
                                        onClick={() => setState({ step: state.step - 1, saved: false })}
                                    >
                                        <NavigateBeforeIcon />
                                    </ColorButton>
                                )}
                            </Box>

                            <Box sx={{ display: 'flex', gap: 1 }}>
                                {typeModal && state.step === maxStep && state.state !== '' && user.permissions.add_serviceorder && state.order && (
                                    <ColorButton
                                        sx={{ width: '8rem', minWidth: '8rem' }}
                                        onClick={() => cloneRow({ order: state.order })}
                                    >
                                        Duplicar OS
                                    </ColorButton>
                                )}

                                {(state.step === maxStep && state.state === 'OPEN' && user.permissions.change_serviceorder && state.saved) && (
                                    <ColorButton
                                        sx={{ width: '8rem', minWidth: '8rem' }}
                                        onClick={() => setState({ showpostpayment: {} })}
                                        disabled={validData}
                                    >
                                        OS Realizada
                                    </ColorButton>
                                )}

                                {!state.saved && (
                                    <Tooltip placement="left" title={validData}>
                                        <>
                                            {state.step !== maxStep && (
                                                <ColorButton
                                                    sx={{ width: '2.5rem', height: '2.5rem' }}
                                                    onClick={() => { disponibilityVerify(state, setLoader, setState) }}
                                                    disabled={validData}
                                                >
                                                    <NavigateNextIcon />
                                                </ColorButton>
                                            )}

                                            {(state.step === maxStep && ['', 'OPEN'].includes(state.state) && user.permissions.add_serviceorder && !state.saved) && (
                                                <ColorButton
                                                    sx={{ width: '8rem', minWidth: '8rem' }}
                                                    onClick={() => setState({
                                                        confirmSubmit: {
                                                            function: () => {
                                                                typeModal
                                                                    ? submit(state, reloadData, setLoader, setState)
                                                                    : duplicar(state, setState, setLoader, reloadData);
                                                                setState({ confirmSubmit: null, saved: true });
                                                            },
                                                            title: 'Confirmar ação.',
                                                            content: 'Deseja salvar a ordem de serviço?',
                                                            okButton: 'Sim'
                                                        }
                                                    })}
                                                    disabled={Array.isArray(validData) ? validData.length === 0 : validData}
                                                >
                                                    Salvar
                                                </ColorButton>
                                            )}
                                        </>
                                    </Tooltip>
                                )}
                            </Box>
                        </Box>
                    </>
                }
            />}
            {state.showpostpayment && <PostPayment parent={state} setParent={setState} reloadData={reloadData} serviceorder_data={data} changedServices={state.changedServices} />}
            {state.newProducts && <ServiceSelection
                handleClose={() => { setState({ newProducts: false }); }}
                reloadProposalRow={() => loadProposalRow(state.id, setState, setLoader)}
                recallData={state}
                submit={(services) => { setState({ newProducts: false, changedServices: services }) }}
                setParent={setState}
                reloadData={() => reloadData()} />}
        </>
    )
}

export default EditServiceOrderModal
